import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bolt, RefreshCcw as ArrowPathIcon, ShieldCheck } from "lucide-react";

export default function FeaturesSection() {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-gray-100 dark:bg-gray-800">
      <div className="container px-4 md:px-6 mx-auto">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-8">
          <a id="features">Key Features</a>
        </h2>
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
          {features.map((feature, index) => (
            <Card key={index} className="bg-background">
              <CardHeader>
                <feature.icon className="w-12 h-12 mb-4 text-primary mx-auto" />
                <CardTitle className="text-lg text-center">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-center">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

const features = [
  {
    icon: Bolt,
    title: "Real-time Visibility",
    description:
      "Monitor package statuses across all your servers in real-time.",
  },
  {
    icon: ArrowPathIcon,
    title: "Automated Updates",
    description: "Schedule and automate package updates to reduce manual work.",
  },
  {
    icon: ShieldCheck,
    title: "Policy Control",
    description:
      "Enforce update policies and ensure compliance across your fleet.",
  },
];
